/**
 * Whether to open the tutorial instead of the home menu.
 *
 * Pure, and separate from the three getters that feed it, because the cost of
 * getting it wrong is asymmetric: too eager and it hijacks the launch of every
 * player who already knows the game, and that is not a bug they can report — it
 * just makes the app feel like it has forgotten them.
 */
export interface FirstRunInputs {
  /** Has this device already been offered the tutorial? */
  seen: boolean;
  /** Is there a round waiting to be picked back up? */
  canResume: boolean;
  /** Lifetime rounds dealt on this profile. */
  roundsPlayed: number;
}

export function shouldOfferTutorial({ seen, canResume, roundsPlayed }: FirstRunInputs): boolean {
  // The flag is newer than the game, so its absence does NOT mean "new player" —
  // it means "we have not asked yet". Anything that proves prior play answers it.
  if (seen) return false;
  if (canResume) return false;
  if (roundsPlayed > 0) return false;
  return true;
}
